import { useEffect, useState } from "react";

const STORAGE_KEY = "kitdex.cookieNotice.v1";

function hasDecided(): boolean {
  try {
    return Boolean(localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

function remember(choice: "accepted" | "dismissed") {
  try {
    localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    /* ignore */
  }
}

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasDecided()) setVisible(true);
  }, []);

  function close(choice: "accepted" | "dismissed") {
    remember(choice);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-notice-title"
      className="fixed inset-x-3 bottom-3 z-[55] sm:left-4 sm:right-auto sm:bottom-4 sm:max-w-sm"
    >
      <div className="border-2 border-foreground bg-card shadow-[6px_6px_0_0_hsl(var(--foreground))]">
        <div className="px-4 pt-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            Cookies
          </span>
        </div>
        <div className="px-4 pb-4 pt-1">
          <p id="cookie-notice-title" className="text-sm text-muted-foreground">
            We use cookies to keep Kitdex running smoothly. That's the whole story.
          </p>
          <div className="mt-4 flex gap-2">
            <button
              onClick={() => close("accepted")}
              className="bg-foreground text-background px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[hsl(var(--primary))] transition-colors"
            >
              Got it
            </button>
            <button
              onClick={() => close("dismissed")}
              className="px-3 py-2 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground"
            >
              No thanks
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
